import { LocationWorkStatus } from 'types/graphql-global-types.d'
import { shiftPageQuery_location as LocationType } from 'components/pages/ShiftPage/types/shiftPageQuery'
import React from 'react'
import ActiveShift from 'components/ActiveShift'
import PageError from 'components/pages/PageError'

const ShiftMenu = ({
  location,
  hideLocationInformation
}: {
  location: LocationType
  hideLocationInformation: boolean
}) => {
  if (location.workStatus === LocationWorkStatus.work_ended) {
    return (
      <div className="h-80">
        <PageError>The shift has ended</PageError>
      </div>
    )
  }

  return (
    <ActiveShift
      hideLocationInformation={hideLocationInformation}
      hideOrdersProgress={false}
      itemSource="web_shift_new"
      locationId={location.id}
    />
  )
}

export default ShiftMenu
